import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=6c7ce692&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=js&"
export * from "./Paging.vue?vue&type=script&lang=js&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=6c7ce692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7ce692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7ce692')) {
      api.createRecord('6c7ce692', component.options)
    } else {
      api.reload('6c7ce692', component.options)
    }
    module.hot.accept("./Paging.vue?vue&type=template&id=6c7ce692&scoped=true&", function () {
      api.rerender('6c7ce692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/Paging.vue"
export default component.exports